import { applyPatches, enablePatches, produceWithPatches } from 'immer';
import { validatePatches } from './validate.js';
enablePatches();
export class UnknownTargetError extends Error {
    targetId;
    constructor(targetId) {
        super(`unknown design target: ${targetId}`);
        this.name = 'UnknownTargetError';
        this.targetId = targetId;
    }
}
export class MissingBaseValueError extends Error {
    key;
    constructor(key) {
        super(`missing base value for reset: ${key}`);
        this.name = 'MissingBaseValueError';
        this.key = key;
    }
}
export class InvalidPatchError extends Error {
    errors;
    constructor(errors) {
        super(`invalid design patches: ${errors.map(({ code }) => code).join(', ')}`);
        this.name = 'InvalidPatchError';
        this.errors = errors;
    }
}
export function makeTransaction(doc, commands, meta = {}) {
    const [next, patches, inverse] = produceWithPatches(doc, (draft) => {
        for (const command of commands) {
            if (command.op === 'invoke')
                continue;
            const targets = command.targets;
            if (targets === 'global') {
                const key = `${command.control}@global`;
                if (command.op === 'set') {
                    draft.globals[command.control] = command.value;
                }
                else {
                    if (!(key in (meta.baseValues ?? {})))
                        throw new MissingBaseValueError(key);
                    const baseValue = meta.baseValues?.[key];
                    if (baseValue === undefined)
                        delete draft.globals[command.control];
                    else
                        draft.globals[command.control] = baseValue;
                }
                continue;
            }
            for (const target of targets) {
                const entity = draft.entities[target];
                if (entity === undefined)
                    throw new UnknownTargetError(target);
                if (command.op === 'set') {
                    entity.props[command.control] = command.value;
                }
                else {
                    const key = `${command.control}@${target}`;
                    if (!(key in (meta.baseValues ?? {})))
                        throw new MissingBaseValueError(key);
                    const baseValue = meta.baseValues?.[key];
                    if (baseValue === undefined)
                        delete entity.props[command.control];
                    else
                        entity.props[command.control] = baseValue;
                }
            }
        }
    });
    return { doc: next, patches: patches, inverse: inverse };
}
export function apply(doc, patches) {
    const validation = validatePatches(patches);
    if (!validation.ok)
        throw new InvalidPatchError(validation.errors);
    return applyPatches(doc, patches);
}
export function invert(tx) {
    return tx.inverse;
}
export function toPointer(path) {
    return `/${path.map((part) => String(part).replaceAll('~', '~0').replaceAll('/', '~1')).join('/')}`;
}
//# sourceMappingURL=apply.js.map